<template>
  <Dropdown
    v-model="internalValue"
    class="w-100"
    :class="{ 'p-invalid': state === false }"
    :options="options"
    option-label="text"
    option-value="value"
    option-disabled="disabled"
    :filter="options.length > 20"
    :filter-placeholder="$t('search')"
    :disabled="locked || disabled"
    @input="handleInput"
  />
</template>

<script>
import Dropdown from 'primevue/dropdown'

export default {
  name: 'SelectField',
  components: { Dropdown },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    state: {
      type: Boolean,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.internalValue = newValue
      },
    },
  },

  methods: {
    handleInput(value) {
      !this.disabled && this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .p-dropdown {
    min-height: 41px;
    width: 100%;

    &.p-disabled {
      color: #313132;
      background-color: #f9f9f9;
      opacity: 1;
    }
  }
</style>
